import React from "react";
const SvgBookmark = props => (
  <svg fill="none" viewBox="0 0 14 16" {...props}>
    <path
      fill="#96A1B0"
      fillRule="evenodd"
      d="M0 2.5A2.5 2.5 0 012.5 0h9A2.5 2.5 0 0114 2.5v13a.5.5 0 01-.805.396l-5.89-4.53a.5.5 0 00-.61 0l-5.89 4.53A.5.5 0 010 15.5v-13zM2.5 1A1.5 1.5 0 001 2.5v11.985l5.085-3.912a1.5 1.5 0 011.83 0L13 14.485V2.5A1.5 1.5 0 0011.5 1h-9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBookmark;
